<template>
  <div>
    <div v-if="userRole !== 'guest'" class="innerItem">
      <button type="button" class="btn btnFull btnPrimary" @click="save">{{locale.save}}</button>
    </div>
    <!-- change language value -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.language}}</div>
      <select class="input" v-model="langs.current">
        <option v-for="lang in usableList" :key="lang.c"
          :value="lang.c"
          :disabled="isNew && lang.c !== langs.default">
          {{ langName(lang.c) }}
        </option>
      </select>
      <p class="mt5 f_light colorGrey">{{langMessage}}</p>
    </div>
    <!-- //change language value -->
    <!-- title -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.title}}</div>
      <input type="text" class="input" v-model="menuData.name">
    </div>
    <!-- //title -->
    <div class="checkbox f_medium">
      <input type="checkbox" id="snsLink" v-model="activeSns" @change="setSns">
      <label for="snsLink">{{locale.menu_enable_sns}}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SetMenuItem',
  props: [
    'locale',
    'isNew',
    'isCopy',
    'langs',
    'activeSns',
    'menuData'
  ],
  computed: {
    userRole () {
      return this.$store.getters['authentication/getAuthInfo'].userRole
    },
    usableList () {
      return this.langs.info.filter(x => {
        return this.langs.usable.indexOf(x.c) !== -1
      })
    },
    langMessage () {
      const langs = this.langs
      const current = langs.current
      let message
      if (langs.manual.includes(current)) {
        message = null
      } else {
        message = this.locale.translate_auto_message
      }
      return message
    }
  },
  methods: {
    langName (c) {
      const code = `lang_${c}`
      const translate = this.langs.manual.includes(c) ? 'translate_manual' : 'translate_auto'
      const isDefault = this.langs.default === c ? `(${this.locale.setting_language_default})` : ''
      return `${this.locale[code]} - ${this.locale[translate]}${isDefault}`
    },
    setSns () {
      this.$emit('setSns', this.activeSns)
    },
    save: function () {
      this.$emit('save')
    }
  }
}
</script>

<style lang="scss" scoped>
.listType {
  margin-bottom: 15px;
}
.setDetail {
  padding: 15px;
  border: 1px solid $color-lgrey2;
  background-color: $color-lgrey2;
}
</style>
